import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { DialogWrapper } from "../../../../../../shared/components/common/dialogWrapper";
import { FsButton } from "../../../../../../shared/components/button";

export const WithdrawErrorDialog = ({ state = false, onClose, error }) => {
  const [isNoIban, setIsNoIban] = useState(false);
  const [isNoBankName, setIsNoBankName] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    if (error) {
      setIsNoIban(Object.hasOwn(error, "IbanIsNullOrEmpty"));
      setIsNoBankName(Object.hasOwn(error, "BankNameIsNullOrEmpty"));
    }
  }, [error]);

  const getErrorMessage = () => {
    if (isNoIban) {
      return t('ibanRequired');
    }
    if (isNoBankName) {
      return t('bankNameRequired');
    }
    return t('minBalanceError');
  };

  return (
    <DialogWrapper
      maxWidth="xs"
      hideCloseBtn
      state={state}
      title={t('withdrawFailed')}
      onClose={() => {
        onClose(false);
      }}
      content={
        <Box className="flex flex-col justify-center">
          <p className="text-center !text-[16px]">
            <span>{getErrorMessage()}</span>
          </p>
        </Box>
      }
      actions={
        <Box className="flex items-center space-x-2">
          <FsButton
            variant="outline"
            onClick={() => {
              onClose(false);
            }}>{t('close')}</FsButton>
        </Box>
      }></DialogWrapper>
  );
};